import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 py-10 px-6 md:px-10">
      <div className="max-w-4xl mx-auto text-center">
        <p className="font-heading text-xl md:text-2xl text-foreground-950 mb-2">Proximité Confiance Finistère</p>
        <p className="font-body text-sm text-foreground-700 tracking-wide">L. Lobbardi — Intervenante</p>
        <div className="mt-4 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm text-foreground-700">
          <span>06 77 45 38 37</span>
          <span className="hidden sm:block text-foreground-400">·</span>
          <span>contact@proximiteconfiancefinistere.fr</span>
        </div>
        <div className="mt-6 flex flex-col sm:flex-row items-center justify-center gap-2 sm:gap-4 text-sm">
          <Link
            to="/mentions-legales"
            className="text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            Mentions légales
          </Link>
          <span className="hidden sm:block text-foreground-400">·</span>
          <Link
            to="/politique-de-confidentialite"
            className="text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
          >
            Politique de confidentialité
          </Link>
        </div>
        <p className="mt-8 text-xs text-foreground-500">
          © {new Date().getFullYear()} Proximité Confiance Finistère. Tous droits réservés.
        </p>
      </div>
    </footer>
  );
}